import { Routes, Route } from "react-router-dom"
import Datasets from "./pages/Datasets"
import NotFoundError from "../../components/Alerts/NotFoundError"
import IndividualDataset from "./pages/IndividualDataset";
import DatasetProtocol from "./pages/DatasetProtocol";

export default function DatasetsRoutes() {


    return (
        <Routes>
            <Route index element={<Datasets />} />
            <Route path=':id' element={<IndividualDataset />} />
            <Route path=':id/protocol' element={<DatasetProtocol />} />
            <Route path='404' element={<NotFoundError />} />
        </Routes>
    )
}